module.exports = __webpack_public_path__ + "static/media/luggage-tag.488416f0.jpg";